import { InputAdornment, Stack, TextField } from '@mui/material';
import { SearchSM } from 'untitledui-js-base';
import { FiltersType } from '../hooks';

export interface RegistryFiltersType {
  search: string;
}

export interface RegistryFiltersProps {
  filters: FiltersType<RegistryFiltersType>;
  disabled?: boolean;
}

export const AccountingDocumentsFilters = ({ filters: { filters, setFilters }, disabled }: RegistryFiltersProps) => (
  <Stack
    direction={{ xs: 'column', md: 'row' }}
    alignItems={{ md: 'center' }}
    spacing={{ xs: 1, md: 3 }}
    width={{ xs: 1, md: 'auto' }}
  >
    <TextField
      placeholder="Vyhledat"
      variant="outlined"
      value={filters.search}
      size="small"
      disabled={disabled}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchSM color="black" />
          </InputAdornment>
        ),
        sx: {
          backgroundColor: 'background.paper'
        }
      }}
      onChange={(e) => setFilters({ ...filters, search: e.target.value })}
    />
  </Stack>
);
